
import Vue from "vue";
import HeaderDropDownFilter from "@/components/BaseHeaderDropDownFilter.vue";

export default Vue.extend({
  name: "ToiletListHeader",

  components: {
    HeaderDropDownFilter
  }
});
